import { httpGet, httpPost, httpPut } from "./AbstractService";

import split from "lodash-es/split";
import last from "lodash-es/last";

import ENDPOINTS from "../data/endpoints.json";

export const ACTION_ATTENDANCE_TAKEN = "A";
export const ACTION_TEACHER_ADD = "B";
export const ACTION_CREATE = "C";
export const ACTION_DELETE = "D";
export const ACTION_DEFAULT_DELETE = "E";
export const ACTION_TEACHER_DELETE = "F";
export const ACTION_DEFAULT_CREATE = "G";
export const ACTION_ROUND_DEFAULT_COUNT = "H";
export const ACTION_DEFAULT_COUNT = "J";
export const ACTION_ROUND_DEFAULT_ADD = "K";
export const ACTION_CLEARED_REPEATS = "L";
export const ACTION_MAXXED = "M";
export const ACTION_DEFAULT_ADD = "N";
export const ACTION_LOGGED_IN = "P";
export const ACTION_READ = "R";
export const ACTION_TRANSFER = "T";
export const ACTION_UPDATE = "U";
export const ACTION_DELETE_BULK = "Z";

export const ENTITY_TYPE_SAD = 1;
export const ENTITY_TYPE_ACTIVITY = 2;
export const ENTITY_TYPE_AD = 3;
export const ENTITY_TYPE_USER = 5;
export const ENTITY_TYPE_USER_LIST = 8;
export const ENTITY_TYPE_SCORE = 11;
export const ENTITY_TYPE_COURSE = 14;
export const ENTITY_TYPE_COURSE_DATE = 15;
export const ENTITY_TYPE_PASS = 16;

export const getAvailableRooms = (school, jwt, dateStart, dateEnd, period) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/report/location/available?dateStart=${dateStart}&dateEnd=${dateEnd}&period=${period}`,
  );
};

export const getReports = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/rpt/report/all`);
};

export const getReportBySlug = (school, jwt, slug) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/rpt/report/slug?name=${slug}`,
  );
};

export const getSlug = () => {
  return last(split(window.location.href, "/"));
};

export const getAttendanceStudent = (school, jwt, eid) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/student/attendance-student?eid=${eid}`,
  );
};

export const getTeacherActivities = (school, jwt, eid) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/teacher/search-teacher-activities?eid=${eid}`,
  );
};

export const getRoomSchedules = (school, jwt, date, locationEid) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/school/room-schedule?date=${date}&locationEid=${locationEid}`,
  );
};

export const getEmptySeats = (school, jwt, date, period) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/school/empty-seats?date=${date}&period=${period}`,
  );
};

export const getActivitiesByDate = (
  school,
  jwt,
  dateStart,
  dateEnd,
  isOpen,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/activity/by-date?dateStart=${dateStart}&dateEnd=${dateEnd}&isOpen=${isOpen}`,
  );
};

export const getStudentsNoActivity = (
  school,
  jwt,
  date,
  grade,
  period,
  studentListEid,
  includeLunches,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/activity/students-no-activity?date=${date}&grade=${grade}&period=${period}&studentListEid=${studentListEid}&includeLunches=${includeLunches}`,
  );
};

export const getStudentListActivities = (
  school,
  jwt,
  dateStart,
  dateEnd,
  categoryEid,
  listEid,
  activitiesExpected,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/student/student-list?dateStart=${dateStart}&dateEnd=${dateEnd}&categoryEid=${categoryEid}&listEid=${listEid}&activitiesExpected=${activitiesExpected}`,
  );
};

export const getStudentActivities = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentEid,
  teacherEid,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/student/student-activities?dateStart=${dateStart}&dateEnd=${dateEnd}&studentEid=${studentEid}&teacherEid=${teacherEid}`,
  );
};

export const getSchoolActivitiesByDatePeriod = (school, jwt, date, period) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/school/weekly-activities?date=${date}&period=${period}`,
  );
};

export const getPreviousAttendance = (
  school,
  jwt,
  activityEid,
  date,
  period,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/activity/previous-attendance?date=${date}&period=${period}&activityEid=${activityEid}`,
  );
};

export const getPassesByStudent = (
  school,
  jwt,
  eid,
  dateStart,
  dateEnd,
  createdByOrFrom,
  groupByUnit,
  groupByAmount,
) => {
  if (groupByUnit === "XX") {
    groupByUnit = "";
  }
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt/pass/student?eid=${eid}&dateStart=${dateStart}&dateEnd=${dateEnd}&createdByOrFrom=${createdByOrFrom}&groupByUnit=${groupByUnit}&groupByAmount=${groupByAmount}`;
  return httpGet(jwt, url);
};

export const getPassesByTeacher = (
  school,
  jwt,
  eid,
  dateStart,
  dateEnd,
  createdByOrFrom,
  groupByUnit,
  groupByAmount,
) => {
  if (groupByUnit === "XX") {
    groupByUnit = "";
  }
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt/pass/teacher?eid=${eid}&dateStart=${dateStart}&dateEnd=${dateEnd}&createdByOrFrom=${createdByOrFrom}&groupByUnit=${groupByUnit}&groupByAmount=${groupByAmount}`;
  return httpGet(jwt, url);
};

export const getTeacherScores = (school, jwt) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/rpt/score/teacher-history`,
  );
};

export const getPassesBasic = (
  school,
  jwt,
  dateStart,
  dateEnd,
  timeStart,
  timeEnd,
  passTypeEid,
  passStatus,
  orderBy,
) => {
  if (passTypeEid === "XX") {
    passTypeEid = "";
  }
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt/pass/basic?dateStart=${dateStart}&dateEnd=${dateEnd}&timeStart=${timeStart}&timeEnd=${timeEnd}&passTypeEid=${passTypeEid}&orderBy=${orderBy}&passStatus=${passStatus}`;
  return httpGet(jwt, url);
};

export const getStudentPassCounts = (
  school,
  jwt,
  dateStart,
  dateEnd,
  orderBy,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt/pass/student-counts?dateStart=${dateStart}&dateEnd=${dateEnd}&orderBy=${orderBy}`;
  return httpGet(jwt, url);
};

export const getSchoolLocationCounts = (school, jwt, date) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt/school/room-counts?date=${date}`;
  return httpGet(jwt, url);
};

export const getActivityMetrics = (school, jwt, date) => {
  const url = `${ENDPOINTS[school.region].school}/rpt/activity/metrics?date=${date}`;
  return httpGet(jwt, url);
};

export const getDailyActivityReport = (school, jwt, date) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt/activity/daily-activity?date=${date}`;
  return httpGet(jwt, url);
};

export const getGlobalUserLists = (school, jwt) => {
  const url = `${ENDPOINTS[school.region].school}/rpt2/meta/user-list/global`;
  return httpGet(jwt, url);
};

export const getDefaultedActivityReport = (school, jwt, date, userListEid) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/defaulted-activity?date=${date}&userListEid=${userListEid}`;
  return httpGet(jwt, url);
};

export const getHomerooms = (school, jwt) => {
  const url = `${ENDPOINTS[school.region].school}/rpt2/meta/homeroom`;
  return httpGet(jwt, url);
};

export const getDefaultedActivityStudentReport = (
  school,
  jwt,
  dateStart,
  dateEnd,
  userEid,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/defaulted-activity-student?dateStart=${dateStart}&dateEnd=${dateEnd}&userEid=${userEid}`;
  return httpGet(jwt, url);
};

export const getReportSchoolActivities = (school, jwt) => {
  const url = `${ENDPOINTS[school.region].school}/rpt2/meta/school/activity`;
  return httpGet(jwt, url);
};

export const getReportSchoolActivityDates = (school, jwt, eid) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/meta/school/activity/${eid}/date`;
  return httpGet(jwt, url);
};

export const getReportActivityAttendance = (
  school,
  jwt,
  activityEid,
  dateStart,
  dateEnd,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/activity-attendance?activityEid=${activityEid}&dateStart=${dateStart}&dateEnd=${dateEnd}`;
  return httpGet(jwt, url);
};

export const getReportAttendanceSummary = (school, jwt) => {
  const url = `${ENDPOINTS[school.region].school}/rpt2/attendance-summary`;
  return httpGet(jwt, url);
};

export const getReportAbsenteeReport = (
  school,
  jwt,
  dateStart,
  dateEnd,
  period,
  activityCategoryEid,
  includeActivitiesWithoutAttendance,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/attendance-school-range?dateStart=${dateStart}&dateEnd=${dateEnd}&period=${period}&activityCategoryEid=${activityCategoryEid}&includeActivitiesWithoutAttendance=${includeActivitiesWithoutAttendance}`;
  return httpGet(jwt, url);
};

export const getReportLateness = (school, jwt, dateStart, dateEnd) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/lateness-school-range?dateStart=${dateStart}&dateEnd=${dateEnd}`;
  return httpGet(jwt, url);
};

export const getReportStudentByCategory = (school, jwt, dateStart, dateEnd) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/student-by-category?dateStart=${dateStart}&dateEnd=${dateEnd}`;
  return httpGet(jwt, url);
};

export const getReportMaxxedActivities = (school, jwt, dateStart, dateEnd) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/maxxed-activities?dateStart=${dateStart}&dateEnd=${dateEnd}`;
  return httpGet(jwt, url);
};

export const getReportMaxxedActivityStudents = (school, jwt, adEid) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/maxxed-activities?adEid=${adEid}`;
  return httpGet(jwt, url);
};


export const getReportMostPopular = (school, jwt, date) => {
  let url = `${ENDPOINTS[school.region].school}/rpt2/most-popular`;

  if (date != null) {
    url += `?date=${date}`;
  }

  return httpGet(jwt, url);
};

export const getCategoryActivities = (school, jwt, categoryEid) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/activity/category/activity?categoryEid=${categoryEid}`,
  );
};

export const getReportRepeatStudents = (
  school,
  jwt,
  dateStart,
  dateEnd,
  activityEids,
  signups,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/repeat-students?dateStart=${dateStart}&dateEnd=${dateEnd}&activityEids=${activityEids}&signups=${signups}`;
  return httpGet(jwt, url);
};

export const getReportActivityCategory = (
  school,
  jwt,
  dateStart,
  dateEnd,
  categoryEids,
  teacherEid,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/activity-category-report?dateStart=${dateStart}&dateEnd=${dateEnd}&categoryEids=${categoryEids}&teacherEid=${teacherEid}`;
  return httpGet(jwt, url);
};

export const getReportLowAttendees = (
  school,
  jwt,
  dateStart,
  dateEnd,
  period,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/low-attendees?dateStart=${dateStart}&dateEnd=${dateEnd}&period=${period}`;
  return httpGet(jwt, url);
};

export const getReportMeetingCodes = (school, jwt, date, teacherEid) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/meeting-codes?date=${date}&teacherEid=${teacherEid}`;
  return httpGet(jwt, url);
};

export const getReportLoginHistory = (school, jwt, userEid) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/login-history?userEid=${userEid}`;
  return httpGet(jwt, url);
};

export const getReportDailyActivityCount = (school, jwt, date) => {
  let url = `${ENDPOINTS[school.region].school}/rpt2/daily-activity-count`;

  if (date != null) {
    url += `?date=${date}`;
  }

  return httpGet(jwt, url);
};

export const getReportUserInactivity = (school, jwt) => {
  const url = `${ENDPOINTS[school.region].school}/rpt2/user-inactivity`;
  return httpGet(jwt, url);
};

export const getReportServicedStudents = (school, jwt, dateStart, dateEnd) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/serviced-students?dateStart=${dateStart}&dateEnd=${dateEnd}`;
  return httpGet(jwt, url);
};

export const getReportDailyTeacherRoster = (school, jwt, date, teacherEid) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/daily-teacher-roster?date=${date}&teacherEid=${teacherEid}`;
  return httpGet(jwt, url);
};

export const getLocationDateActivities = (
  school,
  jwt,
  date,
  period,
  locationId,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/school/location-date?date=${date}&period=${period}&locationId=${locationId}`,
  );
};

export const getReportAbsentAll = (school, jwt, date) => {
  const url = `${ENDPOINTS[school.region].school}/rpt2/absent-all?date=${date}`;
  return httpGet(jwt, url);
};

export const getReportTeacherActivities = (school, jwt, period) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/teacher-activities?period=${period}`;
  return httpGet(jwt, url);
};

export const getReportTeacherNoSignups = (
  school,
  jwt,
  dateStart,
  dateEnd,
  period,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/teacher-0-signups?dateStart=${dateStart}&dateEnd=${dateEnd}&period=${period}`;
  return httpGet(jwt, url);
};

export const getReportTeacherNoAttendance = (
  school,
  jwt,
  dateStart,
  dateEnd,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/teacher-0-attendance?dateStart=${dateStart}&dateEnd=${dateEnd}`;
  return httpGet(jwt, url);
};

export const getReportTeachersWithoutActivities = (
  school,
  jwt,
  dateStart,
  dateEnd,
  proctors,
  period,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/teacher-0-activities?dateStart=${dateStart}&dateEnd=${dateEnd}&proctors=${proctors}&period=${period}`;
  return httpGet(jwt, url);
};

export const getReportTeacherLateCancel = (
  school,
  jwt,
  dateStart,
  dateEnd,
  teacherEid,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/teacher-late-cancel?dateStart=${dateStart}&dateEnd=${dateEnd}&teacherEid=${teacherEid}`;
  return httpGet(jwt, url);
};

export const getReportProctorCounts = (school, jwt) => {
  const url = `${ENDPOINTS[school.region].school}/rpt2/proctor-counts`;
  return httpGet(jwt, url);
};

export const getReportStudentSignups = (
  school,
  jwt,
  date,
  teacherEid,
  period,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/student-signups?date=${date}&period=${period}&teacherEid=${teacherEid}`;
  return httpGet(jwt, url);
};

export const getReportStudentsActivities = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentEids,
) => {
  const studentEidsStr = studentEids.join(",");
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/students-activities?dateStart=${dateStart}&dateEnd=${dateEnd}&studentEids=${studentEidsStr}`;
  return httpGet(jwt, url);
};

export const getReportAttendanceStudentRange = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentRange,
  studentEid,
  studentListEid,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/attendance-student-range?dateStart=${dateStart}&dateEnd=${dateEnd}&studentRange=${studentRange}&studentEid=${studentEid}&studentListEid=${studentListEid}`;
  return httpGet(jwt, url);
};

export const getReportStudentTransfer = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentEid,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/student-transfer?dateStart=${dateStart}&dateEnd=${dateEnd}&studentEid=${studentEid}`;
  return httpGet(jwt, url);
};

export const getReportTopAttendance = (
  school,
  jwt,
  dateStart,
  dateEnd,
  activityEid,
  maxStudents,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/top-attendance?dateStart=${dateStart}&dateEnd=${dateEnd}&activityEid=${activityEid}&maxStudents=${maxStudents}`;
  return httpGet(jwt, url);
};

export const getReportTopDefaulted = (
  school,
  jwt,
  dateStart,
  dateEnd,
  maxStudents,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/top-defaulted?dateStart=${dateStart}&dateEnd=${dateEnd}&maxStudents=${maxStudents}`;
  return httpGet(jwt, url);
};

export const getReportTopAbsentees = (
  school,
  jwt,
  dateStart,
  dateEnd,
  maxStudents,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt2/top-absentees?dateStart=${dateStart}&dateEnd=${dateEnd}&maxStudents=${maxStudents}`;
  return httpGet(jwt, url);
};

export const getReportAbsentStudent = (
  school,
  jwt,
  date,
  selectedStudentEid,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/absent-student?date=${date}&studentEid=${selectedStudentEid}`,
  );
};

export const getReportStudentsPresentDate = (school, jwt, date) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/rpt2/students-present-date?date=${date}`,
  );
};

export const getReportStudentRosters = (school, jwt, firstDate, lastDate) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/student-rosters?firstDate=${firstDate}&lastDate=${lastDate}`,
  );
};

export const getReportStudentsNoActivitySpecific = (
  school,
  jwt,
  date,
  categoryEids,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/students-no-activity-specific?date=${date}&categoryEids=${categoryEids}`,
  );
};

export const getReportUserListActivities = (school, jwt, date, userListEid) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/user-list-activities?date=${date}&userListEid=${userListEid}`,
  );
};

export const getReportConsequencesSchool = (
  school,
  jwt,
  dateStart,
  dateEnd,
  consequenceEid,
  grade,
  excludeFulfilled,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/consequences-school?dateStart=${dateStart}&dateEnd=${dateEnd}&consequenceEid=${consequenceEid}&grade=${grade}&excludeFulfilled=${excludeFulfilled}`,
  );
};

export const getReportConsequencesStudent = (
  school,
  jwt,
  dateStart,
  dateEnd,
  consequenceEid,
  studentEids,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/consequences-student?dateStart=${dateStart}&dateEnd=${dateEnd}&consequenceEid=${consequenceEid}&studentEids=${studentEids}`,
  );
};

export const getReportConsequenceCounts = (
  school,
  jwt,
  dateStart,
  dateEnd,
  consequenceEid,
  orderBy,
  excludeFulfilled,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/consequence-counts?dateStart=${dateStart}&dateEnd=${dateEnd}&consequenceEid=${consequenceEid}&orderBy=${orderBy}&excludeFulfilled=${excludeFulfilled}`,
  );
};

export const getReportSchoolComments = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentEid,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/school/comment/history?dateStart=${dateStart}&dateEnd=${dateEnd}`;

  if (studentEid != null) {
    url += `&studentEid=${studentEid}`;
  }

  return httpGet(jwt, url);
};

export const getReportScoreCounts = (
  school,
  jwt,
  dateStart,
  dateEnd,
  scoreCategoryId,
  includeDeleted,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/score-counts?dateStart=${dateStart}&dateEnd=${dateEnd}&scoreCategoryId=${scoreCategoryId}&includeDeleted=${includeDeleted}`;

  return httpGet(jwt, url);
};

export const getReportScoreMetrics = (
  school,
  jwt,
  dateStart,
  dateEnd,
  scoreCategoryId,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/score-metrics?dateStart=${dateStart}&dateEnd=${dateEnd}&scoreCategoryId=${scoreCategoryId}`;

  return httpGet(jwt, url);
};

export const getReportTeacherScores = (
  school,
  jwt,
  dateStart,
  dateEnd,
  teacherEid,
  scoreCategoryId,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/teacher-scores?dateStart=${dateStart}&dateEnd=${dateEnd}&scoreCategoryId=${scoreCategoryId}&teacherEid=${teacherEid}`;

  return httpGet(jwt, url);
};

export const getReportCheckinStudent = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentEid,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt/checkin/student?dateStart=${dateStart}&dateEnd=${dateEnd}&studentEid=${studentEid}`;

  return httpGet(jwt, url);
};

export const getReportCheckinAll = (
  school,
  jwt,
  dateStart,
  dateEnd,
  userListEid,
  studentType,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt/checkin/all?dateStart=${dateStart}&dateEnd=${dateEnd}&userListEid=${userListEid}&studentType=${studentType}`;

  return httpGet(jwt, url);
};

export const getReportCheckoutAll = (school, jwt, dateStart, dateEnd) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/checkout/all?dateStart=${dateStart}&dateEnd=${dateEnd}`;

  return httpGet(jwt, url);
};

export const getReportSeatTimeDeficit = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentEid,
  grade,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/seat-time-deficit?dateStart=${dateStart}&dateEnd=${dateEnd}&studentEid=${studentEid}&grade=${grade}`;
  return httpGet(jwt, url);
};

export const getReportCheckinsNoCheckout = (
  school,
  jwt,
  dateStart,
  dateEnd,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/checkins-no-checkout?dateStart=${dateStart}&dateEnd=${dateEnd}`;

  return httpGet(jwt, url);
};

export const getReportNoCheckins = (school, jwt, date) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/no-checkins?dateStart=${date}`;
  return httpGet(jwt, url);
};

export const getReportCheckinTimes = (school, jwt, dateStart, dateEnd) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/checkin-times?dateStart=${dateStart}&dateEnd=${dateEnd}`;
  return httpGet(jwt, url);
};

export const getReportPassStudentClusters = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentEids,
  groupByUnit,
  groupByAmount,
  clusterBy,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/pass-student-clusters?dateStart=${dateStart}&dateEnd=${dateEnd}&groupByUnit=${groupByUnit}&groupByAmount=${groupByAmount}&clusterBy=${clusterBy}&studentEids=${studentEids}`;
  return httpGet(jwt, url);
};

export const getReportStudentTimeline = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentEid,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/student-timeline?dateStart=${dateStart}&dateEnd=${dateEnd}&studentEid=${studentEid}`,
  );
};

export const getReportFavorites = (school, jwt) => {
  let url = `${ENDPOINTS[school.region].school}/rpt2/my/favorite`;
  return httpGet(jwt, url);
};

export const addReportFavorite = (school, jwt, reportId) => {
  return httpPost(jwt, `${ENDPOINTS[school.region].school}/rpt2/my/favorite`, {
    reportId,
  });
};

export const removeReportFavorite = (school, jwt, favoriteId) => {
  return httpPut(jwt, `${ENDPOINTS[school.region].school}/rpt2/my/favorite`, {
    favoriteId,
  });
};

export const getReportWatchdog = (
  school,
  jwt,
  userType,
  studentEid,
  teacherEid,
  dateStart,
  dateEnd,
  source,
  maxRows,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/watchdog?dateStart=${dateStart}&dateEnd=${dateEnd}&userType=${userType}&source=${source}&maxRows=${maxRows}`;

  if (userType === "S") {
    url += `&studentEid=${studentEid}`;
  } else if (userType === "T") {
    url += `&teacherEid=${teacherEid}`;
  }

  return httpGet(jwt, url);
};

export const getReportWatchdogDetails = (school, jwt, id) => {
  let url = `${ENDPOINTS[school.region].school}/rpt2/watchdog/details?id=${id}`;
  return httpGet(jwt, url);
};

export const getReportPassBasic = (
  school,
  jwt,
  dateStart,
  dateEnd,
  passTypeEid,
  orderBy,
  maxRows,
) => {
  if (passTypeEid === "XX") {
    passTypeEid = "";
  }

  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/pass/basic?dateStart=${dateStart}&dateEnd=${dateEnd}&passTypeEid=${passTypeEid}&orderBy=${orderBy}&maxRows=${maxRows}`,
  );
};

export const getDashboardSummaries = (school, jwt) => {
  let url = `${ENDPOINTS[school.region].school}/rpt/dash/summaries`;
  return httpGet(jwt, url);
};

export const getCheckinSummaries = (school, jwt) => {
  let url = `${ENDPOINTS[school.region].school}/rpt/dash/checkins`;
  return httpGet(jwt, url);
};

export const getSeatSuggestions = (school, jwt, date) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt/dash/seat-suggestions?date=${date}`;
  return httpGet(jwt, url);
};

export const getPassesByLocation = (
  school,
  jwt,
  eid,
  dateStart,
  dateEnd,
  timeStart,
  timeEnd,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt/pass/location?eid=${eid}&dateStart=${dateStart}&dateEnd=${dateEnd}&timeStart=${timeStart}&timeEnd=${timeEnd}`;
  return httpGet(jwt, url);
};

export const getEventsByDate = (school, jwt, dateStart, dateEnd, typeEid) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/event/events-by-date?dateStart=${dateStart}&dateEnd=${dateEnd}&typeEid=${typeEid}`,
  );
};

export const getEventParents = (school, jwt, eid) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/rpt/event/event-parents?eid=${eid}`,
  );
};

export const getAllEventParents = (school, jwt) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/rpt/event/all-event-parents`,
  );
};

export const getEventParent = (school, jwt, email) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/rpt/event/parent?email=${email}`,
  );
};

export const getStudentsWithoutTeachers = (school, jwt) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].school}/rpt/school/students-without-teachers`,
  );
};

export const getScoresWithoutFulfillments = (
  school,
  jwt,
  dateStart,
  dateEnd,
  grades,
  consequenceEids,
  studentEid,
) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/score/scores-without-fulfillments?dateStart=${dateStart}&dateEnd=${dateEnd}&grades=${grades}&consequenceEids=${consequenceEids}&studentEid=${studentEid}`,
  );
};

export const getUserDashboard = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/user-dash/all`);
};

export const getReportSeatTimeDeficitAll = (
  school,
  jwt,
  dateStart,
  dateEnd,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt2/seat-time-deficit-all?dateStart=${dateStart}&dateEnd=${dateEnd}&grade=0`;
  return httpGet(jwt, url);
};

export const getAttendanceSignupCounts = (
  school,
  jwt,
  dateStart,
  dateEnd,
  attendanceTaken,
) => {
  const url = `${
    ENDPOINTS[school.region].school
  }/rpt/activity/attendance-signup-counts?dateStart=${dateStart}&dateEnd=${dateEnd}&attendanceTaken=${attendanceTaken}`;
  return httpGet(jwt, url);
};

export const getScoreFulfillments = (school, jwt, dateStart, dateEnd) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/score/score-fulfillments?dateStart=${dateStart}&dateEnd=${dateEnd}`,
  );
};

export const getWatchdogFeed = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/rpt/watchdog/feed`);
};

export const getActionText = (actionCode) => {
  switch (actionCode) {
    case ACTION_ATTENDANCE_TAKEN:
      return "Attendance Taken";
    case ACTION_TEACHER_ADD:
      return "Teacher Added";
    case ACTION_CREATE:
      return "Created";
    case ACTION_DELETE:
      return "Deleted";
    case ACTION_DEFAULT_DELETE:
      return "Defaulting Deleted";
    case ACTION_TEACHER_DELETE:
      return "Teacher Deleted";
    case ACTION_DEFAULT_CREATE:
      return "Defaulting Created";
    case ACTION_ROUND_DEFAULT_COUNT:
      return "Round Robin Default Count";
    case ACTION_DEFAULT_COUNT:
      return "Default Count";
    case ACTION_ROUND_DEFAULT_ADD:
      return "Round Robin Default Add";
    case ACTION_CLEARED_REPEATS:
      return "Cleared Repeats";
    case ACTION_MAXXED:
      return "Maxxed";
    case ACTION_DEFAULT_ADD:
      return "Default Added";
    case ACTION_LOGGED_IN:
      return "Logged In";
    case ACTION_READ:
      return "Read";
    case ACTION_TRANSFER:
      return "Transferred";
    case ACTION_UPDATE:
      return "Updated";
    case ACTION_DELETE_BULK:
      return "Created Bulk";
    default:
      return "IDK";
  }
};

export const getEntityTypeText = (result) => {
  switch (result.entityTypeId) {
    case ENTITY_TYPE_SAD:
      return "Student Activity Date";
    case ENTITY_TYPE_ACTIVITY:
      return "Activity";
    case ENTITY_TYPE_AD:
      return "Activity Date";
    case ENTITY_TYPE_USER:
      return "User";
    case ENTITY_TYPE_USER_LIST:
      return "User List";
    case ENTITY_TYPE_SCORE:
      return "Score";
    case ENTITY_TYPE_COURSE:
      return "Course";
    case ENTITY_TYPE_COURSE_DATE:
      return "Course Date";
    case ENTITY_TYPE_PASS:
      return "Pass";
    default:
      return "IDK";
  }
};

export const getBulkAdds = (school, jwt, dateStart, dateEnd) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/rpt/activity/bulk-adds?dateStart=${dateStart}&dateEnd=${dateEnd}`;
  return httpGet(jwt, url);
};

export const getStudentFulfillments = (school, jwt, studentEid) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/score/student-fulfillments?studentEid=${studentEid}`,
  );
};

export const getHomeroomStudents = (
  school,
  jwt,
  dateStart,
  dateEnd,
  teacherEid = null,
) => {
  let url = `${
    ENDPOINTS[school.region].school
  }/homeroom/proctor/student?dateStart=${dateStart}&dateEnd=${dateEnd}`;

  if (teacherEid != null) {
    url += `&teacherEid=${teacherEid}`;
  }
  return httpGet(jwt, url);
};

export const getSchoolEmails = (school, jwt, dateStart, dateEnd, subject) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/school/email?dateStart=${dateStart}&dateEnd=${dateEnd}&subject=${subject}`,
  );
};

export const getActivityTags = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/rpt2/activity-tags`);
};

export const getTeacherActivitiesByDate = (school, jwt, date, teacherEids) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].school}/rpt2/teacher-activities-by-date?date=${date}&teacherEids=${teacherEids.join(",")}`);
};

export const getTeacherSignups = (school, jwt, dateStart, dateEnd) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt/activity/teacher-assigned?dateStart=${dateStart}&dateEnd=${dateEnd}`,
  );
};

export const getDefaultingForecast = (school, jwt, date) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].school
    }/rpt2/defaulting-forecast?date=${date}`,
  );
};
